import { formatDistanceToNow, format, isToday, isYesterday } from 'date-fns';

export const formatTime = (date) => {
  if (!date) return '';
  return format(new Date(date), 'HH:mm');
};

export const formatMessageDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isToday(d))     return formatDistanceToNow(d, { addSuffix: true });
  if (isYesterday(d)) return `Yesterday ${format(d, 'HH:mm')}`;
  return format(d, 'MMM d, HH:mm');
};

export const formatFullDate = (date) => {
  if (!date) return '';
  return format(new Date(date), 'MMMM d, yyyy');
};

export const formatRelativeTime = (date) => {
  if (!date) return '';
  try { return formatDistanceToNow(new Date(date), { addSuffix: true }); }
  catch { return ''; }
};

export const getAvatarUrl = (user) => {
  if (!user) return `https://api.dicebear.com/7.x/avataaars/svg?seed=unknown`;
  if (user.avatar && user.avatar.startsWith('http')) return user.avatar;
  const seed = user.username || user._id || user.id || 'user';
  return `https://api.dicebear.com/7.x/avataaars/svg?seed=${seed}`;
};

export const getInitials = (name) => {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

export const formatFileSize = (bytes) => {
  if (!bytes) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};

export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

export const classNames = (...classes) => classes.filter(Boolean).join(' ');

export const generateRoomId = (id1, id2) => [id1, id2].sort().join('_');

export const truncate = (str, n) => {
  if (!str) return '';
  return str.length > n ? str.slice(0, n) + '...' : str;
};

export const formatCount = (n) => {
  if (!n) return '0';
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000)    return `${(n / 1000).toFixed(1)}K`;
  return n.toString();
};

export const parseHashtags = (text) => {
  if (!text) return '';
  return text.replace(/#(\w+)/g, '<span class="hashtag">#$1</span>');
};

export const timeAgo = (date) => {
  if (!date) return '';
  const seconds = Math.floor((Date.now() - new Date(date)) / 1000);
  if (seconds < 60)   return 'Just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400)return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86400)}d ago`;
};

export const isValidUrl = (str) => {
  try { new URL(str); return true; } catch { return false; }
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch { return false; }
};
